module.exports = __webpack_public_path__ + "img/view.b6193a4c.svg";